import { render, staticRenderFns } from "./TestChoiceAnswer.vue?vue&type=template&id=14ba9e17&"
import script from "./TestChoiceAnswer.vue?vue&type=script&lang=js&"
export * from "./TestChoiceAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports